import { Component, HostListener, OnInit } from '@angular/core';

// Consts
import { translations } from './shared/translations.const';

// Interfaces
import { JWTPayload } from './auth/interfaces/jwt-payload.interface';

// PrimeNG Ripple
import { PrimeNGConfig, MessageService } from 'primeng/api';

// Services
import { AuthService } from './auth/services/auth.service';
import { TokenService } from './auth/services/token.service';
import { EntidadService } from '@entidad/services/entidad.service';
import { WebSocketService } from '@core-services/websocket.service';
import { InactivityService } from '@core-services/inactivity.service';
import { take, tap } from 'rxjs';
import { ConsultaActasService } from '@actas/pages/consulta-actas/services/consulta-actas.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly entidadService: EntidadService,
    private readonly primengConfig: PrimeNGConfig,
    private readonly tokenService: TokenService,
    private readonly consultaActasService: ConsultaActasService,
    private readonly messageService: MessageService,
    private readonly inactivityService: InactivityService,
    private readonly webSocketService: WebSocketService,
  ) {}

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.primengConfig.setTranslation(translations);
    this.authService.currentUser$.subscribe((user) => {
      if (user) {
        this.entidadService.loadDatosEntidad();
        this.inactivityService.startWatching();
        this.webSocketService.autoConnect();
      } else {
        this.inactivityService.stopWatching();
      }
    });
    this.inactivityService.timeout$.subscribe(() => {
      if (!this.authService.isLoggedIn()) return;
      this.messageService.add({
        severity: 'warn',
        summary: 'Sesión expirada',
        detail: 'Su sesión se cerró por inactividad.',
      });
      this.authService.logOut();
    });
    this.consultaListadoEstados();
  }

  consultaListadoEstados() {
    this.consultaActasService.getListaEstados().subscribe({
      next: (estados) => {
        if (!estados || estados.length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Advertencia',
            detail: 'No se encontraron estados.',
          });
        }

        this.consultaActasService.setListaEstados(estados);
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al obtener los estados de las infracciones.',
        });
      },
    });
  }
}
